const SECOND_IN_MS = 1000;
const MINUTE_IN_MS = 60 * SECOND_IN_MS;
const HOUR_IN_MS = 60 * MINUTE_IN_MS;
const DAY_IN_MS = 24 * HOUR_IN_MS;
const WEEK_IN_MS = 7 * DAY_IN_MS;
const MONTH_IN_MS = 30 * DAY_IN_MS;
const YEAR_IN_MS = 365 * DAY_IN_MS;

type RelativeTimeUnit = Intl.RelativeTimeFormatUnit;

function getRelativeTimeValue(diffInMs: number): { value: number; unit: RelativeTimeUnit } {
    const absDiffInMs = Math.abs(diffInMs);

    if (absDiffInMs < MINUTE_IN_MS) {
        return { value: Math.floor(diffInMs / SECOND_IN_MS), unit: "second" };
    }

    if (absDiffInMs < HOUR_IN_MS) {
        return { value: Math.floor(diffInMs / MINUTE_IN_MS), unit: "minute" };
    }

    if (absDiffInMs < DAY_IN_MS) {
        return { value: Math.floor(diffInMs / HOUR_IN_MS), unit: "hour" };
    }

    if (absDiffInMs < WEEK_IN_MS) {
        return { value: Math.floor(diffInMs / DAY_IN_MS), unit: "day" };
    }

    if (absDiffInMs < MONTH_IN_MS) {
        return { value: Math.floor(diffInMs / WEEK_IN_MS), unit: "week" };
    }

    if (absDiffInMs < YEAR_IN_MS) {
        return { value: Math.floor(diffInMs / MONTH_IN_MS), unit: "month" };
    }

    return { value: Math.floor(diffInMs / YEAR_IN_MS), unit: "year" };
}

export function formatFirstSeen(dateString: string, locale: string, now = Date.now()): string | null {
    const firstSeenTimestamp = Date.parse(dateString);

    if (Number.isNaN(firstSeenTimestamp)) {
        return null;
    }

    const diffInMs = firstSeenTimestamp - now;
    const { value, unit } = getRelativeTimeValue(diffInMs);
    const formatter = new Intl.RelativeTimeFormat(locale, { numeric: "always" });

    return formatter.format(value, unit);
}
